import React from "react";
import "./Filter_div_btn.css";

function Filter_div_btn({ btnText, onClick }) {
  return (
    <>
      <section className="filter_div_btn" onClick={onClick}>
        <div className="filter_div">
          <div className="filter_icon_div">
            <p className="text">{btnText}</p>
            <img
              src="/assest/luxury_images/other/filter.png"
              className="filter_img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Filter_div_btn;
